import { BasePack } from '../types';
import { RoutePaths } from '../types/enums';

export function usePartner(pack: BasePack | null | undefined) {
    if (pack) {
        if (pack.label) {
            return {
                route: RoutePaths.Labels,
                slug: pack.label.slug ?? undefined,
            };
        } else if (pack.artist) {
            return {
                route: RoutePaths.Artists,
                slug: pack.artist.slug ?? undefined,
            };
        }
    }

    return null;
}
